import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import routerTree from './config'

const routes: Array<RouteRecordRaw> = [
  {
    path:routerTree.home,
    alias: '/',
    name: "home",
    component: () =>
    import(/* webpackChunkName: "home" */ "../views/Home/Home.vue"),
    props: route => ({ queryInfo: {
                                  isDetail:route.query.isDetail,
                                  currentNewsId:route.query.currentNewsId,
                                  currentVersionName:route.query.currentVersionName,
                                  currentVersion:route.query.currentVersion,
                                  timeValue:route.query.timeValue,
                                } 
                    })
  },
  {
    path: routerTree.personCenter.main,
    name: "personCenter",
    component: () =>
      import(/* webpackChunkName: "personCenter" */ "../views/PersonCenter/PersonCenter.vue"),
      children: [
        {
          path: '', // 默认子路由
          redirect: routerTree.personCenter.userInfo // 重定向到 profile
        },
        {
          path: routerTree.personCenter.userInfo, // 个人信息
          name: 'userInfo',
          component: () =>
          import(/* webpackChunkName: "userInfo" */ "../views/PersonCenter/components/UserInfo.vue"),
        },
        {
          path: routerTree.personCenter.accountActive, // 账号激活
          name: 'accountActive',
          component: () =>
          import(/* webpackChunkName: "personCenter" */ "../views/PersonCenter/components/AccountActive.vue"),
        },
        {
          path: routerTree.personCenter.myOrder, // 我的订单
          name: 'myOrder',
          component: () =>
          import(/* webpackChunkName: "myOrder" */ "../views/PersonCenter/components/MyOrder.vue"),
        },
        // {
        //   path: routerTree.personCenter.myInvoice, // 我的发票
        //   name: 'myInvoice',
        //   component: () =>
        //   import(/* webpackChunkName: "myInvoice" */ "../views/PersonCenter/components/MyInvoice.vue"),
        // },
        {
          path: routerTree.personCenter.myCollect, // 我的收藏
          name: 'myCollect',
          component: () =>
          import(/* webpackChunkName: "myCollect" */ "../views/PersonCenter/components/MyCollect.vue"),
        },
        {
          path: routerTree.personCenter.firmTeam, // 企业合作
          name: 'firmTeam',
          component: () =>
          import(/* webpackChunkName: "firmTeam" */ "../views/PersonCenter/components/FirmTeam.vue"),
        },
      ]
  },
  {
    path:routerTree.login,
    name: "login",
    component: () =>
    import(/* webpackChunkName: "home" */ "../views/Login/Login.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
